import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { f as g } from "./index-LyFokDcn.mjs";
import { m as c } from "./tss-DN0acMKN.mjs";
import { g as m } from "./get-encore-value-Di648HqV.mjs";
const x = c()((a, n) => {
  const { constructs: e, palette: r } = a, { backgroundColor: o, borderColor: u, borderPlacement: t, v2: l } = n, s = m(u, {
    none: "transparent",
    "neutral-extra-extra-weak": void 0,
    "neutral-extra-weak": void 0,
    "neutral-forced-white": void 0,
    "neutral-inverted": void 0,
    ...g.ifFeature(
      "encore",
      {
        "neutral-weak": e.border.neutral.weak,
        "neutral-medium": e.border.neutral.medium,
        "neutral-strong": e.border.neutral.strong,
        "neutral-extra-strong": e.border.neutral.xStrong,
        ...l && {
          "neutral-extra-extra-weak": e.border.neutral.xxWeak,
          "neutral-extra-weak": e.border.neutral.xWeak,
          "neutral-inverted": e.border.neutral.inverted,
          "neutral-forced-white": e.border.neutral.forcedWhite
        }
      },
      {
        ...l ? {
          "neutral-weak": r.gray[300],
          "neutral-medium": r.gray[400],
          "neutral-strong": r.gray[500],
          "neutral-extra-strong": r.gray[700]
        } : {
          "neutral-weak": r.gray[200],
          "neutral-medium": r.gray[300],
          "neutral-strong": r.gray[400],
          "neutral-extra-strong": r.gray[500]
        }
      }
    )
  }), d = s && `1px solid ${s}`;
  return {
    root: {
      backgroundColor: m(o, {
        none: "transparent",
        "neutral-forced-white": e.surface.neutral.forcedWhite,
        "neutral-extra-weak": e.surface.neutral.xWeak,
        ...g.ifFeature(
          "encore",
          {
            "neutral-weak": e.surface.neutral.weak,
            "neutral-medium": e.surface.neutral.medium,
            "neutral-strong": e.surface.neutral.strong,
            "neutral-extra-strong": e.surface.neutral.xStrong
          },
          {
            ...l ? {
              "neutral-extra-weak": r.gray[100],
              "neutral-weak": r.gray[200],
              "neutral-medium": r.gray[400],
              "neutral-strong": r.gray[600],
              "neutral-extra-strong": r.gray[800]
            } : {
              "neutral-weak": r.common.white,
              "neutral-medium": r.gray[100],
              "neutral-strong": r.gray[200],
              "neutral-extra-strong": r.gray[300]
            }
          }
        )
      }),
      borderBottom: t === "bottom" ? d : "",
      borderTop: t === "top" ? d : ""
    }
  };
});
function y({ backgroundColor: a, borderColor: n = "neutral-medium", borderPlacement: e = "top", children: r, v2: o, ...u }) {
  const { classes: t } = x({ backgroundColor: a, borderColor: n, borderPlacement: e, v2: o });
  return /* @__PURE__ */ i.jsx("div", { ...u, className: t.root, "data-fabric-component": "Slat", children: r });
}
export {
  y as S
};
//# sourceMappingURL=slat-hn-wD3c1.mjs.map
